import React from 'react';
import ShadowButton from '~/components/ShadowButton';

export default function CompanyBottomNav({dark = false, items}) {
  return items ? (
    <section className="my-20 md:my-28">
      <div className="container">
        <div className="grid items-center gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {items?.map((link, i) => (
            <ShadowButton key={`companybottomnav${i}`} className="flex-auto w-full" {...link} dark={dark} />
          ))}
        </div>
      </div>
    </section>
  ) : null;
}
